var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TrackingEventShopFunnel } from "../features/game-tracking/custom-types/TrackingEventShopFunnel";
import { DeviceType } from "../features/game-tracking/types/DeviceTypeEnum";
import { FeedbackSource } from "../features/game-tracking/types/FeedbackSourceEnum";
import { PlatformType } from "../features/game-tracking/types/PlatformTypeEnum";
import { SessionType } from "../features/game-tracking/types/SessionTypeEnum";
import { ShopType } from "../features/game-tracking/types/ShopTypeEnum";
import { StoreType } from "../features/game-tracking/types/StoreTypeEnum";
import { TrackingEventClientFunnel } from "../features/game-tracking/types/TrackingEventClientFunnel";
import { TrackingEventDesktopDeviceInformation } from "../features/game-tracking/types/TrackingEventDesktopDeviceInformation";
import { TrackingEventFeedback } from "../features/game-tracking/types/TrackingEventFeedback";
import { TrackingEventFpsAndMemoryUsage } from "../features/game-tracking/types/TrackingEventFpsAndMemoryUsage";
import { TrackingEventGamePaymentshopClick } from "../features/game-tracking/types/TrackingEventGamePaymentshopClick";
import { utilTracking } from "../utils/tracking/utilTracking";
import { utilFps } from "../utils/utilFps";
import { utilMemoryUsage } from "../utils/utilMemoryUsage";
import { utilVersion } from "../utils/utilVersion";
export var selectGameTrackingClientFunnelData = function (state, gameState) {
    var gameCredentials = selectGameBaseTrackingCredentials();
    var country = utilTracking.getLandingPageCredentials().country;
    return new TrackingEventClientFunnel(__assign({}, gameCredentials, { account_hash: utilTracking.getAccountHash(), client_language_code: country, client_timestamp: utilTracking.getGameClientTimeStamp(), client_version: utilVersion.getCurrentVersion(), connection_type_name: "LAN", device_id: DeviceType.DESKTOP, device_language_code: country, gamestate_count_session: utilTracking.getGameStateCount(), gamestate_name: gameState, platform_id: PlatformType.WEB, referrer_name: utilTracking.referrer, session_count: utilTracking.getGameSessionCount(), session_length_ms: utilTracking.getTimeSinceStart(), session_type_name: SessionType[utilTracking.getGameSessionType()] })).data;
};
export var selectGameTrackingShopData = function (state, shopStep, shopStepData) {
    var gameCredentials = selectGameBaseTrackingCredentials();
    var country = utilTracking.getLandingPageCredentials().country;
    return new TrackingEventShopFunnel(__assign({}, gameCredentials, { account_hash: utilTracking.getAccountHash(), client_language_code: country, client_timestamp: utilTracking.getGameClientTimeStamp(), client_version: utilVersion.getCurrentVersion(), connection_type_name: "LAN", device_id: DeviceType.DESKTOP, platform_id: PlatformType.WEB, session_id: utilTracking.getStartTime(), session_length_ms: utilTracking.getTimeSinceStart(), shop_id: ShopType.Shop3, shop_step_count_session: utilTracking.getShopStateCount(), shop_step_name: selectShopStepName(shopStep, shopStepData), store_id: StoreType.WEB })).data;
};
export var selectShopStepName = function (shopStep, shopStepData) {
    var stepData = shopStepData ? "#" + shopStepData : "";
    return "" + shopStep + stepData;
};
export var selectGameTrackingPaymentShopClick = function (state, clickSourceId) {
    var gameCredentials = selectGameBaseTrackingCredentials();
    return new TrackingEventGamePaymentshopClick(__assign({}, gameCredentials, { clickSourceId: clickSourceId, client_timestamp: utilTracking.getGameClientTimeStamp(), deviceId: DeviceType.DESKTOP, sessionId: "" + utilTracking.getGameSessionCount(), storeId: StoreType.WEB })).data;
};
export var selectGameTrackingFeedback = function (state, message) {
    var gameCredentials = selectGameBaseTrackingCredentials();
    var language = utilTracking.getLandingPageCredentials().language;
    var data = new TrackingEventFeedback(__assign({}, gameCredentials, { client_timestamp: utilTracking.getGameClientTimeStamp(), date: utilTracking.getGameClientTimeStamp(), feedback_data: message, feedback_source_id: FeedbackSource.LOH_INGAME, feedback_source_language_code: language })).data;
    if (data.event_mapping_version != undefined && data.event_mapping_version === 1) {
        delete data.event_mapping_version;
    }
    return data;
};
export var selectGameTrackingFpsAndMemoryUsage = function (state, eventName) {
    var gameCredentials = selectGameBaseTrackingCredentials();
    // todo: add memory usage
    return new TrackingEventFpsAndMemoryUsage(__assign({}, gameCredentials, { client_trigger_name: eventName, fps: utilFps.getFps(), fps_avg: utilFps.getAvgFps(), fps_max: utilFps.getMaxFps(), fps_min: utilFps.getMinFps(), memoryUsage: utilMemoryUsage.getMemoryUsage(), memory_avg: utilMemoryUsage.getAvgMemoryUsage(), memory_max: utilMemoryUsage.getMaxMemoryUsage(), memory_min: utilMemoryUsage.getMinMemoryUsage(), timestamp: utilTracking.getGameClientTimeStamp() })).data;
};
export var selectGameTrackingDesktopDeviceInformation = function () {
    var gameCredentials = selectGameBaseTrackingCredentials();
    var data = new TrackingEventDesktopDeviceInformation(__assign({}, gameCredentials, { browserString: utilTracking.getBrowserName(), client_timestamp: utilTracking.getGameClientTimeStamp(), desktopOs: utilTracking.getOperativeSystem(), flashVersion: "0.0.0", var_1: utilTracking.getAccountHash(), var_2: window.innerWidth, var_3: window.innerHeight })).data;
    if (data.event_mapping_version != undefined && data.event_mapping_version === 1) {
        delete data.event_mapping_version;
    }
    return data;
};
var selectGameBaseTrackingCredentials = function () {
    var _a = utilTracking.getLandingPageCredentials(), gameId = _a.gameId, instanceId = _a.instanceId, networkId = _a.networkId, playerId = _a.playerId;
    return {
        gameId: gameId,
        instanceId: instanceId,
        networkId: networkId,
        playerId: playerId,
        zoneId: 1,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectGameTrackingData.ts
// module id = 1690
// module chunks = 3